import { useEffect, useReducer, useRef } from 'react';

import { IEntityPdfExportConfig } from '@opengov/reporting-types';
import { useDebounce } from '../../../hooks/useDebounce';
import { IColumnNameFilters } from '../../../types/MultiDatasetTypes';
import { createActions, IActionsPDF } from './actions';
import { APPLY_ENTITY_CONFIG, formReducer, FormState, initForm } from './reducer';

interface FormStateWithDebounce extends FormState {
  debounceMaxColumnWidth: number;
}

const DEBOUNCE_DELAY = 300;
export const usePdfState = (
  entityTitle: string,
  reportTitle: string,
  currentSavedViewTitle: string,
  currentViewFilters: IColumnNameFilters,
  entityPdfExportConfig?: IEntityPdfExportConfig | null
): [FormStateWithDebounce, IActionsPDF] => {
  const [state, dispatch] = useReducer(formReducer, {
    ...initForm,
    ...(entityPdfExportConfig as Partial<FormState>),
    primaryTitle: entityTitle,
    secondaryTitle: reportTitle,
    subtitle: currentSavedViewTitle,
    showAppliedFilters: Object.keys(currentViewFilters).length > 0
  });

  // When the component mounts before entityPdfExportConfig is available (config fetched
  // after modal opens), apply the config once it arrives without remounting the form.
  const configAppliedRef = useRef(false);
  useEffect(() => {
    if (entityPdfExportConfig && !configAppliedRef.current) {
      configAppliedRef.current = true;
      dispatch({ type: APPLY_ENTITY_CONFIG, payload: entityPdfExportConfig as unknown as FormState[keyof FormState] });
    }
  }, [entityPdfExportConfig]);

  const debounceMaxColumnWidth = useDebounce(state.maxColumnWidth, DEBOUNCE_DELAY);
  const actions = createActions(dispatch);
  return [{ ...state, debounceMaxColumnWidth }, actions];
};
